import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import {
    Portlet, PortletBody, PortletHeader,PortletHeaderToolbar
} from "../../partials/content/Portlet";
import {
    Grid,
    IconButton,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Box,
    CircularProgress,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { PagedTable } from '../../common';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import Alert from '@mui/material/Alert';
import { errorToastify } from '../../util/toast';
import { ClaimQuickSearch } from './ClaimAuditQuickSeach/ClaimAuditQuickSearch';
import ProcessedAuditClaims from './ProcessedAuditClaims/ProcessedAuditClaims'

const DEFAULT_SORT = [
    { id: 'id', direction: 'desc' }
];

const useStyles = makeStyles(theme => ({
    button: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1),
    },

    processClaimBtn: {
        "&:hover": {
            backgroundColor: 'whitesmoke', // Change background color on hover
            transform: 'scale(1.1)', // Scale effect
            transition: 'transform 0.2s ease', // Smooth transition
            cursor:'pointer',
            borderRadius: '50%'
        }
      },
      grid:{display:'grid',alignItems:'center'}
}));

export default function ClaimAuditsPage(props, openPtr) {
    const classes = useStyles();
    const [refresh, setRefresh] = useState(Promise.resolve());
    const [isProcessSuccessDialogOpen, setProcessSuccessDialogOpen] = useState(false);
    const [loadingRows, setLoadingRows] = useState({}); 
    const [processResult, setProcessResult] = useState(null);
    const [isInMemoryDialogOpen, setInMemoryDialogOpen] = useState(false);
    
    const {
        fields,
        auditData,
        filter,
        sort,
        processClaimsPending,
        claimNumber,
        actions: {
            claimAuditsLanding,
            searchGetByName,
            searchReset,
            setMulti,
            processClaimsFromAudit,
            processClaimFromAudit,
            auditErrorReset,
            resetPagedTable,
            resetCriteriaWaiting
        }
    } = props;

    useEffect(() => {
        const pageName = {
            name: 'claim-audits-landing'
        }
        
        resetCriteriaWaiting(pageName.name)

        return function cleanup() {
            resetPagedTable(pageName.name)
        }
    }, [searchGetByName, searchReset]);

    const claimNumberFilter = (cn) => 
       ( {
            "operator": "and",
            "filters": [
                {
                    "id": "claimnumber",
                    "equator": "equals",
                    "value": cn
                }
            ]
        })
    

    function handleLoad(sort, filter, pagination) {
        let refactoredFilters = {};
        if (!filter && claimNumber) {
            refactoredFilters = {
                ...filter,
                operands: [claimNumberFilter(claimNumber)],
            };
        } else if (filter && claimNumber) {
            refactoredFilters = {
                ...filter,
                operands: [...filter.operands, claimNumberFilter(claimNumber)],
            };
        }
        claimAuditsLanding(
            pagination,
            sort,
            claimNumber ? refactoredFilters : filter
        );
        errorReset();
    }

    function handleRefresh() {
        setRefresh(Promise.resolve());
    }   
   
    function handleProcessClaims() {
       const  refactoredFilters = {
                ...filter,
                operands: [...(filter?.operands || []), claimNumberFilter(claimNumber)],
            };
        errorReset();
        if ((filter === null || filter?.length === 0) && !claimNumber) {
            // setErrorToast("At least one filter should be selected");
            errorToastify("At least one Claim Should be selected From Filters.")
            return
        }
        if (auditData.length > 1000) {
            errorToastify("Please select more filter to narrow down search results. The results should be lesser than 1000.");
            return
        }
        const payload = {
            page: null,
            filter:claimNumber ? refactoredFilters: filter || null,
            sort: sort || [],
        };
        processClaimsFromAudit(payload, handleProcessCallback);
    }

    function handleProcessClaim(auditId) {
        errorReset();
        setLoadingRows(prevState => ({ ...prevState, [auditId]: true })); 
        const payload = {
            page: null,
            filter:  {
                operator: "And",
                operands: [
                    {
                        operator: "and",
                        filters: [
                            {
                                "id": "id",
                                "equator": "equals",
                                "value": auditId
                            }
                        ]
                    }
                ] 
            },
            sort: sort || [],
        };
        processClaimFromAudit(payload, (result) => handleSingleProcessCallback(result, auditId)); 
    }

    function handleProcessCallback(result) {        
        if (result?.hasInMemoryExecution) {
            setProcessResult(result); 
            setInMemoryDialogOpen(true);
        } else {
            setProcessSuccessDialogOpen(true);
        }
    }

    function handleSingleProcessCallback(result, auditId) {
        setLoadingRows(prevState => ({ ...prevState, [auditId]: false }));
        
        if (result?.hasInMemoryExecution) {
            setProcessResult(result); 
            setInMemoryDialogOpen(true);
        } else {
            setProcessSuccessDialogOpen(true);
        }
    }

    function errorReset() {
        auditErrorReset();
    }

    function handleProcessDialogClose() {
        setProcessSuccessDialogOpen(false);
    }

    const claimAuditTableLevelActions = () => {
        return (
            <>
                <Grid item className={classes.grid}>
                    <Tooltip title="Process Claims">
                        <Box onClick={handleProcessClaims} className={classes.processClaimBtn}>
                            <PlayCircleOutlineIcon />
                        </Box>
                    </Tooltip>
                </Grid>
            </>
        );
    }

    function claimAuditRowLevelActions(rowData) {
        const auditId = rowData?.id;
        const isRowLoading = loadingRows[auditId]; 
        return (
            <>             
                <Grid item>
                    <Tooltip title="Process Claim">
                       <IconButton   aria-label="edit" className={classes.processClaimBtn} size='small' onClick={() => handleProcessClaim(auditId)}>
                         {isRowLoading ? (
                                <CircularProgress size={16} color="secondary" />
                            ) : (
                                <PlayCircleOutlineIcon />
                            )}
                        </IconButton>
                    </Tooltip>
                </Grid>
            </>
        );
    }

    return (<>
        <Helmet title="Claim Audits" />
        <Portlet>
            <PortletHeader
                title="Claim Audits"
                name="claim-audits-landing"
                handleRefresh={handleRefresh}
                showSearchFilters={true}
                showSearchFiltersDropdown={false}
                includeAdvanceFilters={true}
                toolbar={
                    claimNumber ? (
                        <></>
                    ) : (
                        <PortletHeaderToolbar>
                            <ClaimQuickSearch
                                pending={false}
                                classes={classes}
                                handleRefresh={handleRefresh}
                                setMulti={setMulti}
                            />
                        </PortletHeaderToolbar>
                    )
                }
        />
            <PortletBody>
                <div>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <PagedTable
                                name="claim-audits-landing"
                                title="Claim Audits"
                                fields={fields}
                                renderActionColumn={claimAuditRowLevelActions}
                                hasActions={true}
                                data={auditData}
                                onLoad={handleLoad}
                                refresh={refresh}
                                defaultSort={DEFAULT_SORT}
                                criteriasSaveEnabled={true}
                                tableLevelActions={claimAuditTableLevelActions}
                                tableLevelLoading={processClaimsPending}
                                showSearchFilters={true}
                                shouldRenderLazy={true}
                            />
                        </Grid>
                    </Grid>
                </div>
            </PortletBody>
        </Portlet>
        <Dialog open={isProcessSuccessDialogOpen} onClose={handleProcessDialogClose}>
            <DialogTitle>
                Process Claims
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Alert severity="success">The request is submitted and progress can be monitored on execution logs page.</Alert>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleProcessDialogClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
        <ProcessedAuditClaims 
            open={isInMemoryDialogOpen} 
            rows={processResult?.claimSummaries}
            onClose={() => setInMemoryDialogOpen(false)} />
    </>);
}